import {DownloadPlatform, LocalDownloadInfo, Release} from "../javaTypes";
import LocalDownload from "./LocalDownload";
import { createRoot } from "react-dom/client";

declare global {
    interface Window { channelToken: string, downloadInfo: Record<DownloadPlatform, LocalDownloadInfo>, releases: Release[] }
}

const container = document.getElementById('localDownloadContainer');
if (container) {
    const root = createRoot(container)
    root.render(<LocalDownload channelToken={window.channelToken} downloadInfo={window.downloadInfo} releases={window.releases} />);
} else {
    console.error("Container element not found")
}